export const WORKING_HOURS_MODEL = "working-hour";

const workingHoursModel = {
  name: ""
};

export default workingHoursModel;
